<template>
  <textarea ref="textarea" :value="value" @input="update($event.target.value)" :readonly="state !== 'editor'"></textarea>
</template>

<script>
  export default {
    props: ['value', 'state'],
    mounted() {
      this.autoHeight();
    },
    methods: {
      update(value) {
        this.$refs.textarea.value = value;
        this.$emit('input', value);
        this.autoHeight();
      },
      autoHeight() {
        this.$refs.textarea.style.height = '5px';
        this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + "px";
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  textarea {
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// pricing-table-textarea.vue?3f47544f